import React from "react";
import "./CardSlot.css";
import type { PositionReading } from "../../tarot/reading/types";
import { CardReading } from "./CardReading";

export interface CardSlotProps {
  index: number;
  title?: string;
  subtitle?: string;
  reading?: PositionReading | null;
}

export const CardSlot: React.FC<CardSlotProps> = ({
  index,
  title,
  subtitle,
  reading,
}) => {
  const isFilled = Boolean(reading);

  return (
    <article
      className={
        isFilled
          ? "tarot-slot tarot-slot--filled"
          : "tarot-slot"
      }
    >
      <header className="tarot-slot__header">
        <div className="tarot-slot__index">
          Позиция {index}
        </div>

        <div className="tarot-slot__title">
          {title ?? `Позиция ${index}`}
        </div>

        {subtitle ? (
          <div className="tarot-slot__subtitle">
            {subtitle}
          </div>
        ) : null}
      </header>

      <div
        className="tarot-slot__surface"
        aria-label={`Слот карты #${index}`}
      >
        {reading ? (
          <CardReading reading={reading} />
        ) : (
          <div className="tarot-slot__placeholder">
            <div className="tarot-slot__placeholder-number">
              {index}
            </div>

            <div className="tarot-slot__placeholder-symbol">
              ✦
            </div>

            <div className="tarot-slot__placeholder-text">
              Карта появится после расклада
            </div>
          </div>
        )}
      </div>
    </article>
  );
};

